import MapElementDataStream from "./MapElementDataStream";

export default class AnnotationDataStream extends MapElementDataStream {
    constructor(id, forceAllVisible = false) {
        super(id, forceAllVisible);
    }
}